
export default (data) => ({
  title: data?.subtitle ?? '',
  json: data?.description?.json ?? undefined,
  video: {
    url: data?.video?.localAsset?.publicURL ?? '',
    contentType: data?.video?.contentType ?? '',
  },
})
